import { useNavigate } from 'react-router-dom';
import { Stack, Group, Text, Box } from '@repletoryreach/sdk-ui';
import type { admin } from '@repletoryreach/sdk-api';
import { formatDateTime, formatRelative } from '../../../lib/format';
import { TenantName } from '../../../components/TenantName';
import { RunStatusBadge } from './RunStatusBadge';
import { formatDuration } from '../lib/duration';
import { useT } from '../../../i18n/I18nProvider';

type FlowRun = NonNullable<Awaited<ReturnType<typeof admin.listFlowRuns>>['data']>[number];

export function FlowsList({ records }: { records: FlowRun[] }) {
  const navigate = useNavigate();
  const t = useT();
  return (
    <Stack gap="xs">
      {records.map((r) => (
        <button
          key={r.id}
          type="button"
          onClick={() => navigate(`/flows/${r.id}`)}
          className="rr-list-row"
        >
          <Group gap="md" align="center" wrap="nowrap" style={{ width: '100%' }}>
            <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
              <Group gap="xs" align="baseline" wrap="nowrap">
                <Text role="subtitle" fw={600} truncate>
                  {r.flow_name ?? t('flows.flowDeleted')}
                </Text>
                {r.contact_msisdn && (
                  <Text role="caption" c="var(--rr-color-text-muted)" truncate>{t('flows.list.for', { msisdn: r.contact_msisdn })}</Text>
                )}
              </Group>
              <Group gap="xs" align="baseline" wrap="nowrap" style={{ minWidth: 0 }}>
                <TenantName id={r.organisation_id} subtle />
                <Text role="caption" c="var(--rr-color-text-muted)" truncate>
                  · {t('flows.list.started', { at: formatRelative(r.started_at) })}
                  <span title={formatDateTime(r.started_at)}> · {formatDuration(r.started_at, r.finished_at)}</span>
                  {' · '}{r.channel}
                </Text>
              </Group>
              {r.error && (
                <span title={r.error} style={{ minWidth: 0 }}>
                  <Text role="caption" c="var(--rr-color-error)" truncate>{r.error}</Text>
                </span>
              )}
            </Stack>
            <Box style={{ flexShrink: 0 }}>
              <RunStatusBadge status={r.status} size="sm" />
            </Box>
          </Group>
        </button>
      ))}
    </Stack>
  );
}
